import { ContentfulAsset } from '../Contentful';

export const PAGE_SIZE = 10;

export const EMPTY_SEARCH: SearchResponse = {
  hits: [],
  total: 0,
  skip: 0,
  limit: 0,
  query: '',
};

export const DEFAULT_SEARCH_LOCALE = 'en-US';

export interface SearchQuery {
  query: string;
  limit?: number;
  skip?: number;
  contentTypes?: string[];
  related?: boolean;
  fields?: string[];
  tags?: string[];
  suggest?: boolean;
  debug?: boolean;
  locale?: string;
}

export interface SearchHit {
  contentType: string;
  id: string;
  title: string;
  urlSlug: string;
  url: string;
  linkExternal?: boolean;
  label?: string;
  description?: string;
  videoUrl?: string;
  duration?: string;
  image?: ContentfulAsset;
  date?: string;
  location?: string;
  categories?: Array<{
    name?: string;
    urlSlug?: string;
    icon?: ContentfulAsset;
  }>;
  score: number;
  isSearchHit: boolean;
}

export interface SearchResponse {
  hits: SearchHit[];
  query: string;
  limit: number;
  skip: number;
  total: number;
  profile?: any;
}

export { searchLoader } from './searchLoader';
export { SearchResultsComponent } from './SearchResultsComponent';
export { SearchBar } from './SearchBar';
export { itemToSearchHit } from './content';
